import React from "react";
import { Button } from "@/components/ui/button";
import { openPdf } from "@/lib/pdf";
import { toast } from "sonner";
import { Plus, Camera as CameraIcon, FileDown } from "lucide-react";

/** Header row: title + action buttons (PDF export, Appointment, Check-in). */
export default function VisitorsHeader({ user, isGate, onNewAppointment, onCheckIn }) {
  const canExportPdf = ["admin", "super-admin", "manager", "accounts"].includes(user?.role);
  const download30dLogPdf = async () => {
    const to = new Date();
    const from = new Date(); from.setDate(from.getDate() - 30);
    const fmt = (d) => d.toISOString().slice(0, 10);
    try { await openPdf(`/api/reports/visitors-log.pdf?date_from=${fmt(from)}&date_to=${fmt(to)}`); }
    catch { toast.error("PDF failed"); }
  };
  return (
    <div className="flex items-start justify-between flex-wrap gap-3" data-testid="visitors-header">
      <div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#4A5A50]">Gate</div>
        <h1 className="font-serif text-3xl lg:text-4xl font-medium">Visitors</h1>
      </div>
      <div className="flex flex-wrap gap-2">
        {canExportPdf && (
          <Button
            variant="outline"
            className="rounded-full"
            onClick={download30dLogPdf}
            data-testid="visitor-log-pdf-btn"
          ><FileDown size={14} className="mr-1"/> Log PDF (30d)</Button>
        )}
        <Button
          variant="outline"
          className="rounded-full"
          onClick={onNewAppointment}
          data-testid="visitor-appt-btn"
        ><Plus size={14} className="mr-1"/> Appointment</Button>
        {isGate && (
          <Button
            className="rounded-full bg-[#0F5E39] hover:bg-[#083F22] text-white"
            onClick={onCheckIn}
            data-testid="visitor-checkin-btn"
          ><CameraIcon size={14} className="mr-1"/> Check-in</Button>
        )}
      </div>
    </div>
  );
}
